import { useContext } from 'react'
import SvgLogo from '#/assets/images/logos/logo-hexa.svg'
import ViewModeContext from '#/contexts/ViewMode'
import cn from '#/utils/classnames'

type InsightCardProps = {
  title: string
  description: string
}

const InsightCard: React.FC<InsightCardProps> = ({ title, description }) => {
  const viewMode = useContext(ViewModeContext)

  return (
    <div
      className={cn(
        'inline-flex items-start h-24 p-4 py-3 overflow-hidden whitespace-pre-wrap bg-white rounded-lg shadow space-x-2',
        { 'border-gray-400 border-2 mt-4 w-[22.2rem]': viewMode === 'PDF_FULL_PROPERTY' }
      )}
    >
      <div className='inline-flex h-full items-center'>
        {viewMode === 'WEB_DETAIL_PAGE' && <SvgLogo className='mr-2 h-5 w-5 flex-none' />}
      </div>
      <div>
        <div className='line-clamp-1 w-full text-sm font-semibold text-gray-800'>
          {title}
        </div>
        <div className='mt-1 line-clamp-3 w-44 text-xs leading-tight text-gray-500'>
          {description}
        </div>
      </div>
    </div>
  )
}

export default InsightCard
